
























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { getRecord } from '@/api/team/team'
import { getFromType } from '@/api/task/common'
import { DOMAIN } from '@/global/constants';

@Component
export default class ExamRecord extends Vue {
  private dataList: object[] = [];
  private total: number | string = 0;
  private task: object = {};
  private searchParams: object = {
      title:'',
      gid:'',
      page: '1',
      pagesize: '20',
  };
  private columnsSchema: object[] = [
    {
      title: '任务名称',
      key: 'title',
      align: 'center',
    },
    {
      title: '任务ID',
      key: 'gid',
      align: 'center',
    },
    {
      title: '考核结果',
      slot: 'status',
      align: 'center',
    },
    {
      title: '参与时间',
      slot: 'time',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'operate',
      align: 'center',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'examrecord') {
      this.getList();
    }
  }
  private getStatus(check_status){
    if (check_status === 0) {
        return '未考核';
    } else if (check_status === 1) {
        return '成功';
    } else if (check_status === 2) {
        return '失败';
    } else if (check_status === 3) {
        return '处理中';
    }
  }

  private created() {
    this.getList()
  }
  private async getList() {
    const task: any = this.task;
    let params: any = JSON.parse(JSON.stringify(this.searchParams))
    if (params.title == '' ) {
        delete params.title
    }
    if(params.gid  == '') {
      delete params.gid
    }
    try {
      const data = (await getRecord(params)) as any;
      this.$nextTick(() => {
        this.dataList = data.rows;
        this.total = data.total;
      });
    } catch (error) {
      console.log(error);
    }
  }
  // 查看详情
  private async handleShow(id,gid){
    try {
      const res: any = await getFromType({ gid: gid });
      let from = res.from;
      if (from.indexOf('sketch') > -1) {
        from = from.indexOf('-') > -1 ? from.split('-')[1] : 'markPage';
      }
      window.open(
        `${DOMAIN}/tools/${from}.html?type=222&id=${id}`
      );
    } catch (error) {
      console.log(error);
    }
  }
  // 搜索
  private handleSearch() {
    this.getList();
  }
  // 分页
  private changePage(data) {
    this.searchParams = Object.assign(this.searchParams, {
      page: data,
    });
    this.getList();
  }

  // 重置
  private handlereset() {
    this.searchParams = {
      title:'',
      gid:'',
      page: '1',
      pagesize: '20',
    };
    this.getList();
  }
}
